<template>
  <div>
    <v-data-table
      class="elevation-1"
      :headers="headers"
      :items="items"
      :loading="isLoading"
    >
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
    },
    isLoading: {
      type: Boolean,
    },
    headers: {
      type: Array,
    },
  },
};
</script>

